export default __webpack_public_path__ + "static/media/movie_app_reactJS.e1b87c40.PNG";